var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 376.057,
    height: 290.095,
    viewBox: "0 0 376.057 290.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_880",
    "data-name": "Gruppe 880",
    transform: "translate(-0.204 -73.38)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_567",
    "data-name": "Ellipse 567",
    cx: 186.6,
    cy: 23.45,
    rx: 186.6,
    ry: 23.45,
    transform: "translate(0.204 316.832) rotate(-6)",
    fill: "#00587f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_693",
    "data-name": "Gruppe 693",
    transform: "translate(13 73.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1267",
    "data-name": "Pfad 1267",
    d: "M479.251,250.921H432.768V240.868a2.4,2.4,0,0,0-2.4-2.4h-13.65V227.754a1.514,1.514,0,0,0-1.514-1.514H397.616a1.514,1.514,0,0,0-1.514,1.514v10.713H380.055a2.4,2.4,0,0,0-2.4,2.4v10.054H333.325a.489.489,0,0,0-.485.489v133.46a.489.489,0,0,0,.485.489h29.458a.489.489,0,0,0,.489-.489V366.918a.493.493,0,0,1,.489-.489h12.444a.493.493,0,0,1,.489.489v17.956a.489.489,0,0,0,.485.489h58.21a.493.493,0,0,0,.489-.489V366.918a.489.489,0,0,1,.485-.489h12.444a.489.489,0,0,1,.489.489v17.956a.493.493,0,0,0,.489.489h29.458a.493.493,0,0,0,.489-.489V251.41a.493.493,0,0,0-.482-.489ZM358,360.193a.485.485,0,0,1-.485.485H339.319a.485.485,0,0,1-.489-.485V354a.489.489,0,0,1,.489-.489h18.206a.489.489,0,0,1,.485.489Zm0-16.058a.485.485,0,0,1-.485.489h-18.2a.485.485,0,0,1-.489-.489v-6.211a.485.485,0,0,1,.489-.489h18.206a.485.485,0,0,1,.485.489Zm0-16.055a.489.489,0,0,1-.485.489H339.319a.489.489,0,0,1-.489-.489v-6.215a.489.489,0,0,1,.489-.489h18.206a.489.489,0,0,1,.485.489Zm0-16.058a.485.485,0,0,1-.485.489h-18.2a.485.485,0,0,1-.489-.489v-6.193a.485.485,0,0,1,.489-.489h18.206a.485.485,0,0,1,.485.489Zm0-16.055a.489.489,0,0,1-.485.489H339.319a.489.489,0,0,1-.489-.489v-6.215a.485.485,0,0,1,.489-.485h18.206a.485.485,0,0,1,.485.485Zm0-16.055a.485.485,0,0,1-.485.485h-18.2a.485.485,0,0,1-.489-.485V273.7a.489.489,0,0,1,.489-.489h18.206a.489.489,0,0,1,.485.489Zm0-16.058a.485.485,0,0,1-.485.489h-18.2a.485.485,0,0,1-.489-.489v-6.193a.485.485,0,0,1,.489-.489h18.206a.485.485,0,0,1,.485.489Zm43.137,96.335a.485.485,0,0,1-.489.485h-18.2a.489.489,0,0,1-.489-.485V354a.493.493,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Zm0-16.058a.485.485,0,0,1-.489.489h-18.2a.489.489,0,0,1-.489-.489v-6.207a.489.489,0,0,1,.489-.489h18.2a.485.485,0,0,1,.489.489Zm0-16.055a.489.489,0,0,1-.489.489h-18.2a.493.493,0,0,1-.489-.489v-6.211a.493.493,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Zm0-16.058a.485.485,0,0,1-.489.489h-18.2a.489.489,0,0,1-.489-.489v-6.189a.489.489,0,0,1,.489-.489h18.2a.485.485,0,0,1,.489.489Zm0-16.055a.489.489,0,0,1-.489.489h-18.2a.493.493,0,0,1-.489-.489v-6.211a.489.489,0,0,1,.489-.485h18.2a.485.485,0,0,1,.489.485Zm0-16.055a.485.485,0,0,1-.489.485h-18.2a.489.489,0,0,1-.489-.485V273.7a.493.493,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Zm0-16.058a.485.485,0,0,1-.489.489h-18.2a.489.489,0,0,1-.489-.489v-6.189a.489.489,0,0,1,.489-.489h18.2a.485.485,0,0,1,.489.489Zm29.476,96.335a.485.485,0,0,1-.489.485h-18.2a.489.489,0,0,1-.489-.485V354a.493.493,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Zm0-16.058a.485.485,0,0,1-.489.489h-18.2a.489.489,0,0,1-.489-.489v-6.2a.489.489,0,0,1,.489-.489h18.2a.485.485,0,0,1,.489.489Zm0-16.055a.489.489,0,0,1-.489.489h-18.2a.493.493,0,0,1-.489-.489v-6.207a.493.493,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Zm0-16.058a.485.485,0,0,1-.489.489h-18.2a.489.489,0,0,1-.489-.489v-6.186a.489.489,0,0,1,.489-.489h18.2a.485.485,0,0,1,.489.489Zm0-16.055a.489.489,0,0,1-.489.489h-18.2a.492.492,0,0,1-.489-.489v-6.207a.489.489,0,0,1,.489-.485h18.2a.485.485,0,0,1,.489.485Zm0-16.055a.485.485,0,0,1-.489.485h-18.2a.489.489,0,0,1-.489-.485V273.7a.493.493,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Zm0-16.058a.485.485,0,0,1-.489.489h-18.2a.489.489,0,0,1-.489-.489v-6.186a.489.489,0,0,1,.489-.489h18.2a.485.485,0,0,1,.489.489Zm43.137,96.335a.489.489,0,0,1-.489.485h-18.2a.485.485,0,0,1-.489-.485V354a.489.489,0,0,1,.489-.489h18.2a.493.493,0,0,1,.489.489Zm0-16.058a.489.489,0,0,1-.489.489h-18.2a.485.485,0,0,1-.489-.489v-6.2a.485.485,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Zm0-16.055a.493.493,0,0,1-.489.489h-18.2a.489.489,0,0,1-.489-.489v-6.2a.489.489,0,0,1,.489-.489h18.2a.493.493,0,0,1,.489.489Zm0-16.058a.489.489,0,0,1-.489.489h-18.2a.485.485,0,0,1-.482-.478v-6.193a.485.485,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Zm0-16.055a.493.493,0,0,1-.489.489h-18.2a.489.489,0,0,1-.489-.489v-6.2a.485.485,0,0,1,.489-.485h18.2a.489.489,0,0,1,.489.485Zm0-16.055a.489.489,0,0,1-.489.485h-18.2a.485.485,0,0,1-.489-.485v-6.2a.489.489,0,0,1,.489-.489h18.2a.493.493,0,0,1,.489.489Zm0-16.058a.489.489,0,0,1-.489.489h-18.2a.485.485,0,0,1-.482-.478v-6.193a.485.485,0,0,1,.489-.489h18.2a.489.489,0,0,1,.489.489Z",
    transform: "translate(-242.223 -179.307)",
    fill: "#eef5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1268",
    "data-name": "Pfad 1268",
    d: "M275.823,119.121l-5.621,3.564,3.412-6.207a5.559,5.559,0,0,0-3.4-1.213h-.091a6.549,6.549,0,0,1-1.166-.087l-1.9,1.206.815-1.485a6.758,6.758,0,0,1-3.332-2.535l-3.408,2.173,2.151-3.915a9.969,9.969,0,0,0-7.638-3.861c-3.546,0-6.7,2.108-8.743,5.393a6.519,6.519,0,0,1-5.795,3.115h-.188c-3.915,0-7.087,4.44-7.087,9.912s3.187,9.916,7.1,9.916a5.331,5.331,0,0,0,2.466-.619,10.216,10.216,0,0,1,8.58-.167,8.931,8.931,0,0,0,7.294,0,10.224,10.224,0,0,1,8.5.167,5.331,5.331,0,0,0,2.445.619c3.915,0,7.087-4.44,7.087-9.916a12.566,12.566,0,0,0-1.481-6.059Z",
    transform: "translate(-179.071 -103.099)",
    fill: "#eef5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1269",
    "data-name": "Pfad 1269",
    d: "M265.255,156.377a10.463,10.463,0,0,0-6.073.659,8.942,8.942,0,0,1-7.29,0,10.242,10.242,0,0,0-8.58.167,5.292,5.292,0,0,1-2.47.619c-3.477,0-6.37-3.5-6.972-8.123a6.674,6.674,0,0,0,1.738-1.876c2.039-3.285,5.2-5.393,8.743-5.393s6.664,2.082,8.692,5.335a6.693,6.693,0,0,0,5.776,3.173h.091C261.691,150.919,264.089,153.139,265.255,156.377Z",
    transform: "translate(-179.097 -125.85)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1270",
    "data-name": "Pfad 1270",
    d: "M859.906,102.818,857.1,104.6l1.7-3.1a2.778,2.778,0,0,0-1.695-.6h-.043a3.115,3.115,0,0,1-.583-.043l-.949.6.406-.724a3.4,3.4,0,0,1-1.662-1.26l-1.7,1.086,1.086-1.952a4.965,4.965,0,0,0-3.806-1.956,5.187,5.187,0,0,0-4.346,2.691,3.259,3.259,0,0,1-2.9,1.554h-.094c-1.952,0-3.535,2.213-3.535,4.944s1.583,4.944,3.535,4.944a2.651,2.651,0,0,0,1.231-.308,5.1,5.1,0,0,1,4.277-.083,4.466,4.466,0,0,0,3.64,0,5.11,5.11,0,0,1,4.241.083,2.64,2.64,0,0,0,1.217.3c1.952,0,3.535-2.213,3.535-4.944a6.3,6.3,0,0,0-.75-3.013Z",
    transform: "translate(-565.059 -96.65)",
    fill: "#eef5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1271",
    "data-name": "Pfad 1271",
    d: "M854.622,121.384a5.259,5.259,0,0,0-3.031.33,4.447,4.447,0,0,1-1.811.384,4.494,4.494,0,0,1-1.811-.391,5.107,5.107,0,0,0-4.281.083,2.64,2.64,0,0,1-1.231.308c-1.735,0-3.176-1.746-3.477-4.053a3.354,3.354,0,0,0,.869-.934,4.867,4.867,0,0,1,8.692-.029,3.339,3.339,0,0,0,2.9,1.583h.047A3.633,3.633,0,0,1,854.622,121.384Z",
    transform: "translate(-565.059 -107.984)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1272",
    "data-name": "Pfad 1272",
    d: "M659.09,190.872l-3.3,2.09,2-3.622a3.26,3.26,0,0,0-1.992-.724h-.054a3.907,3.907,0,0,1-.685-.051l-1.115.724.478-.873a3.984,3.984,0,0,1-1.956-1.481l-2,1.268,1.264-2.3a5.849,5.849,0,0,0-4.48-2.267,6.144,6.144,0,0,0-5.128,3.165,3.825,3.825,0,0,1-3.39,1.811h-.112c-2.3,0-4.154,2.6-4.154,5.795s1.858,5.813,4.154,5.813a3.1,3.1,0,0,0,1.449-.362,6,6,0,0,1,5.03-.1,5.259,5.259,0,0,0,4.277,0,6,6,0,0,1,4.987.1,3.144,3.144,0,0,0,1.449.362c2.3,0,4.158-2.6,4.158-5.813a7.388,7.388,0,0,0-.884-3.538Z",
    transform: "translate(-434.615 -152.136)",
    fill: "#eef5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1273",
    "data-name": "Pfad 1273",
    d: "M652.879,212.723a6.156,6.156,0,0,0-3.564.388,5.259,5.259,0,0,1-4.277,0,6,6,0,0,0-5.03.1,3.111,3.111,0,0,1-1.449.362c-2.039,0-3.737-2.053-4.089-4.762a3.893,3.893,0,0,0,1.018-1.086,5.737,5.737,0,0,1,10.235-.036,3.918,3.918,0,0,0,3.386,1.862h.04C650.785,209.522,652.194,210.825,652.879,212.723Z",
    transform: "translate(-434.615 -165.479)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1274",
    "data-name": "Pfad 1274",
    d: "M945.048,607.488c0,.623,0,1.246-.04,1.862a44.014,44.014,0,0,1-.862,7.131c-2.379,11.629-9.25,20.669-17.88,23.338a17.852,17.852,0,0,1-5.3.808c-13.3,0-24.084-14.849-24.084-33.138s10.782-33.138,24.084-33.138c12.477,0,22.74,13.06,23.961,29.788C945.008,605.239,945.048,606.358,945.048,607.488Z",
    transform: "translate(-601.99 -401.345)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1275",
    "data-name": "Pfad 1275",
    d: "M976.262,623.392a44.029,44.029,0,0,1-.862,7.131c-2.379,11.629-9.25,20.669-17.88,23.338-6.682-3.075-11.64-14.6-11.64-28.346,0-16.1,6.809-29.154,15.211-29.154,7.051,0,12.984,9.206,14.7,21.7C976.034,619.77,976.189,621.559,976.262,623.392Z",
    transform: "translate(-633.244 -415.384)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1276",
    "data-name": "Pfad 1276",
    d: "M695.88,452.27s65.189-13.4,99.594-1.086c0,0,5.07,2.535,0,6.881,0,0,4.8,5.07-3.578,6.881l-33.265,2.046L695.88,460.6Z",
    transform: "translate(-473.784 -319.466)",
    fill: "#94b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1277",
    "data-name": "Pfad 1277",
    d: "M727.38,458.513s55.813-11.473,85.271-.931c0,0,4.346,2.173,0,5.892,0,0,4.1,4.346-3.064,5.892l-28.48,1.749-53.727-5.465Z",
    transform: "translate(-493.876 -324.024)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1278",
    "data-name": "Pfad 1278",
    d: "M742.145,476.15l-4.346-8.692s1.9-8.793-13.581-11.379c-.858-3.835-4.748-6.729-9.416-6.729-4.556,0-8.366,2.752-9.351,6.446-2.224.192-4.592.453-7.127.8l-3.542,18.992-.442-.884s2.249-10.387-18.021-11.9a7.54,7.54,0,0,0,1.724-4.755c0-4.6-4.3-8.33-9.6-8.33s-9.6,3.727-9.6,8.33a7.605,7.605,0,0,0,2.014,5.1q-2.843.272-6,.7L650.88,485.2l18.47,2.535,29.335-4.346-2.6-5.2,16.721,2.3Z",
    transform: "translate(-445.081 -321.615)",
    fill: "#00587f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1279",
    "data-name": "Pfad 1279",
    d: "M742.145,476.15l-4.346-8.692s1.9-8.793-13.581-11.379c-.858-3.835-4.748-6.729-9.416-6.729-4.556,0-8.366,2.752-9.351,6.446-2.224.192-4.592.453-7.127.8l-3.542,18.992-.442-.884s2.249-10.387-18.021-11.9a7.54,7.54,0,0,0,1.724-4.755c0-4.6-4.3-8.33-9.6-8.33s-9.6,3.727-9.6,8.33a7.605,7.605,0,0,0,2.014,5.1q-2.843.272-6,.7L650.88,485.2l18.47,2.535,29.335-4.346-2.6-5.2,16.721,2.3Z",
    transform: "translate(-445.081 -321.615)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1280",
    "data-name": "Pfad 1280",
    d: "M722.568,440.959s-2.9-16.254,10.5-16.616,9.054,23.541,9.054,23.541,10.141,2.173,10.865,6.157-35.13,5.07-35.13,5.07Z",
    transform: "translate(-487.804 -305.662)",
    fill: "#00587f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1281",
    "data-name": "Pfad 1281",
    d: "M553.62,640.7c0,19.195-14.269,34.767-31.87,34.767s-31.87-15.573-31.87-34.767,14.447-37.846,32.051-37.846S553.62,621.494,553.62,640.7Z",
    transform: "translate(-342.39 -419.524)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_549",
    "data-name": "Ellipse 549",
    cx: 25.351,
    cy: 29.331,
    rx: 25.351,
    ry: 29.331,
    transform: "translate(154.009 193.289)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_550",
    "data-name": "Ellipse 550",
    cx: 31.87,
    cy: 34.768,
    rx: 31.87,
    ry: 34.768,
    transform: "translate(7.334 183.142)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1282",
    "data-name": "Pfad 1282",
    d: "M315.959,469.35s-14.849.724-14.124,8.692,12.676,2.173,12.676,2.173Z",
    transform: "translate(-222.431 -334.372)",
    fill: "#94b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1283",
    "data-name": "Pfad 1283",
    d: "M444.648,423.1l6.113-40.8s1.449-5.07-18.108-5.07c0,0-62.654-3.984-78.589,2.535,0,0-18.47,6.881-44.184,42.373C309.88,422.136,442.113,425.268,444.648,423.1Z",
    transform: "translate(-227.579 -274.844)",
    fill: "#c2d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1284",
    "data-name": "Pfad 1284",
    d: "M454.147,388.35,442.92,432.9l-7.04-.17-33.319-.811L328.248,430.1c-.206-3.52,34.985-39.943,34.985-39.943Z",
    transform: "translate(-239.294 -282.707)",
    fill: "#94b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1285",
    "data-name": "Pfad 1285",
    d: "M533.47,458.7l3.035-11.734s-2.9-16.257,10.5-16.62,9.054,23.541,9.054,23.541,9.235,1.981,10.705,5.624Z",
    transform: "translate(-370.193 -309.489)",
    fill: "#00587f",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1286",
    "data-name": "Pfad 1286",
    d: "M425.869,552.012c-2.173-21.005-15.754-25.532-15.754-25.532-13.038-.724-21.73,48.892-21.73,48.892l-100.319,9.054s3.441-42.192-20.824-49.073-30.6,42.554-31.689,49.435-146.313-.724-150.3-3.622-2.535-30.784-1.449-32.957,3.984-11.951,3.984-11.951a20.063,20.063,0,0,1,2.043-7.327c.652-1.449,1.217-2.452,1.217-2.452,3.147-17.847,19.488-22.168,20.585-22.454h.058c4.346-4.346,44.546-7.243,44.546-7.243l15.211-2.9,123.667,2.43,5.262.105,62.871-3.024,42.518-2.046c9.778,0,14.849,24.627,14.849,24.627C429.672,537.707,425.869,552.012,425.869,552.012Z",
    transform: "translate(-82.63 -348.405)",
    fill: "#c2d7e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_551",
    "data-name": "Ellipse 551",
    cx: 18.644,
    cy: 11.672,
    rx: 18.644,
    ry: 11.672,
    transform: "translate(113.348 167.582) rotate(-21.92)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_552",
    "data-name": "Ellipse 552",
    cx: 18.644,
    cy: 11.672,
    rx: 18.644,
    ry: 11.672,
    transform: "translate(112.624 166.132) rotate(-21.92)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1287",
    "data-name": "Pfad 1287",
    d: "M126.322,528.39c-.185,3.984-1.97,9.011-5.183,13.853-5.168,7.794-12.256,12.382-16.62,11.039.652-1.449,1.217-2.452,1.217-2.452C108.884,532.982,125.225,528.662,126.322,528.39Z",
    transform: "translate(-96.592 -372.03)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1288",
    "data-name": "Pfad 1288",
    d: "M123.322,526.39c-.185,3.984-1.97,9.011-5.183,13.853-5.168,7.794-12.256,12.382-16.62,11.039.652-1.449,1.217-2.452,1.217-2.452C105.884,530.982,122.225,526.662,123.322,526.39Z",
    transform: "translate(-94.679 -370.755)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1289",
    "data-name": "Pfad 1289",
    d: "M166.309,452.674H137.7l-1.449-3.984h34.768Z",
    transform: "translate(-86.905 -286.192)",
    fill: "#94b9c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_553",
    "data-name": "Ellipse 553",
    cx: 6.519,
    cy: 6.519,
    r: 6.519,
    transform: "translate(117.069 209.942)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    cx: 6.519,
    cy: 6.519,
    r: 6.519,
    transform: "translate(116.345 208.855)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 3.259,
    cy: 6.881,
    rx: 3.259,
    ry: 6.881,
    transform: "translate(1.901 204.509)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_556",
    "data-name": "Ellipse 556",
    cx: 3.259,
    cy: 6.881,
    rx: 3.259,
    ry: 6.881,
    transform: "translate(0.815 204.147)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1290",
    "data-name": "Pfad 1290",
    d: "M748.131,534.067c-3.984,12.314-4.346,31.508-4.346,31.508l-1.449,5.07-70.622,7.968s.362-35.492,1.449-52.151a67.623,67.623,0,0,0-3.814-26.543l5.262.105L737.484,497C747.986,504.363,751.706,523.01,748.131,534.067Z",
    transform: "translate(-456.862 -352.008)",
    fill: "rgba(148,185,201,0.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1291",
    "data-name": "Pfad 1291",
    d: "M839.5,536.328a1.778,1.778,0,0,0-1.637,2.061,1.271,1.271,0,0,0,.724.945c1.17.583,8.956-.724,11.908-1.246a2,2,0,0,0,1.673-1.785c.036-.514-.152-.953-.905-.953Z",
    transform: "translate(-564.329 -376.47)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1292",
    "data-name": "Pfad 1292",
    d: "M668.88,485.4s1.811,7.968,10.5,5.432l2.9-11.227-5.795-3.259Z",
    transform: "translate(-456.563 -338.837)",
    fill: "#94b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1293",
    "data-name": "Pfad 1293",
    d: "M691.945,452.263c3.984-2.361,10.3-4.426,16.554.532a7.388,7.388,0,0,1,2.133,8.887c-2.046,4.429-6.9,9.235-18.242,3.48a7.316,7.316,0,0,1-2.76-2.441l-.058-.087a7.352,7.352,0,0,1,2.372-10.372Z",
    transform: "translate(-468.983 -321.874)",
    fill: "#94b9c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_557",
    "data-name": "Ellipse 557",
    cx: 7.243,
    cy: 7.243,
    r: 7.243,
    transform: "translate(172.299 213.744)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_558",
    "data-name": "Ellipse 558",
    cx: 3.984,
    cy: 7.243,
    rx: 3.984,
    ry: 7.243,
    transform: "translate(325.131 200.707)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_580",
    "data-name": "Rechteck 580",
    width: 9.416,
    height: 12.676,
    rx: 4.708,
    transform: "translate(174.653 198.715)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1294",
    "data-name": "Pfad 1294",
    d: "M901.1,510.19h0a2.535,2.535,0,0,1,2.535,2.535v5.795a4.346,4.346,0,0,1-4.346,4.346h0a2.535,2.535,0,0,1-2.535-2.535v-5.795A4.346,4.346,0,0,1,901.1,510.19Z",
    transform: "translate(-571.981 -325.419)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1295",
    "data-name": "Pfad 1295",
    d: "M983.726,712.526h0a4.346,4.346,0,0,1-4.346-4.346V704.2a4.346,4.346,0,0,1,4.346-4.346h0c2.39,0,2.173,1.956,2.173,4.346v3.984C985.9,710.57,986.123,712.526,983.726,712.526Z",
    transform: "translate(-654.611 -481.394)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1296",
    "data-name": "Pfad 1296",
    d: "M873.647,556.19h0a4.346,4.346,0,0,1,4.346,4.346v5.432a2.9,2.9,0,0,1-2.9,2.9h0a4.346,4.346,0,0,1-4.346-4.346v-5.432A2.9,2.9,0,0,1,873.647,556.19Z",
    transform: "translate(-555.398 -354.759)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1297",
    "data-name": "Pfad 1297",
    d: "M1019.362,659.472c0,.623,0,1.246-.04,1.862a44.015,44.015,0,0,1-.862,7.131,4.423,4.423,0,0,1-.724.062,4.346,4.346,0,0,1-4.346-4.346V660.2a4.346,4.346,0,0,1,4.346-4.346,4.242,4.242,0,0,1,1.123.148c.13.036.261.076.384.123C1019.322,657.223,1019.362,658.342,1019.362,659.472Z",
    transform: "translate(-676.304 -453.329)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_581",
    "data-name": "Rechteck 581",
    width: 9.416,
    height: 12.676,
    rx: 4.708,
    transform: "translate(192.942 214.107)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_582",
    "data-name": "Rechteck 582",
    width: 9.416,
    height: 12.676,
    rx: 4.708,
    transform: "translate(157.45 214.107)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_583",
    "data-name": "Rechteck 583",
    width: 9.416,
    height: 12.676,
    rx: 4.708,
    transform: "translate(174.834 232.939)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1298",
    "data-name": "Pfad 1298",
    d: "M906.445,292.091a5.948,5.948,0,0,1-.362,2.024,6.012,6.012,0,0,1-11.26.159,5.915,5.915,0,0,1-.413-2.173,6.012,6.012,0,0,1,12.024,0Z",
    transform: "translate(-600.414 -217.482)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1299",
    "data-name": "Pfad 1299",
    d: "M894.764,291.122a6.012,6.012,0,0,1,2.34-8.174,5.95,5.95,0,0,1,2.173-.724,6.012,6.012,0,1,0,.507,11.977A6.008,6.008,0,0,1,894.764,291.122Z",
    transform: "translate(-599.548 -215.013)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_584",
    "data-name": "Rechteck 584",
    width: 16.105,
    height: 25.123,
    transform: "translate(292.504 82.982)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_585",
    "data-name": "Rechteck 585",
    width: 16.105,
    height: 25.123,
    transform: "translate(292.866 82.258)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1300",
    "data-name": "Pfad 1300",
    d: "M798.467,577.46s-1.717,4.708-5.795,5.367a28.377,28.377,0,0,0-6.432,1.709l9.662,6.226,5.154-.645s.641-6.657,2.789-8.16S798.467,577.46,798.467,577.46Z",
    transform: "translate(-531.419 -403.329)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1301",
    "data-name": "Pfad 1301",
    d: "M1002.581,577.46s1.717,4.708,5.795,5.367a28.124,28.124,0,0,1,6.439,1.72l-9.662,6.226-5.154-.645s-.641-6.657-2.789-8.16S1002.581,577.46,1002.581,577.46Z",
    transform: "translate(-665.738 -403.329)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1302",
    "data-name": "Pfad 1302",
    d: "M834.851,462.44a7.5,7.5,0,0,0-3.437,3.864,14.991,14.991,0,0,0-7.3,5.585s-3.22,3.433-3.651,5.154-5.367,12.038-5.367,12.038-4.936,16.1-7.515,17.822c0,0,8.159-1.72,9.662,6.439,0,0,1.934,0,4.082-7.515s7.3-16.746,7.3-16.746,1.72-6.443,3.223-7.515,3.864-6.012,6.012-4.726,16.319-.214,16.319-.214,8.373,3.864,8.587,6.443,1.72,2.789,1.934,4.936,8.16,19.111,8.16,19.111,1.5,4.708,1.93,5.795c0,0,4.726-11.379,10.952-4.94,0,0-.214-4.3-2.148-6.881s-10.307-22.762-10.307-22.762-.858-3.006-1.717-3.864-7.515-7.729-9.873-7.729c0,0-1.289-3.223-2.792-3.651Z",
    transform: "translate(-545.031 -329.965)",
    fill: "#00587f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1303",
    "data-name": "Pfad 1303",
    d: "M793.071,599.5a10.463,10.463,0,0,1-10.224-1.376,20.378,20.378,0,0,0-4.56-2.64c-2.274-.92-5-1.6-5.831-.062-1.5,2.789,18.253,9.662,18.253,9.662S793.284,603.578,793.071,599.5Z",
    transform: "translate(-522.575 -414.203)",
    fill: "#00587f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1304",
    "data-name": "Pfad 1304",
    d: "M1003.208,599.5a10.463,10.463,0,0,0,10.224-1.376,20.377,20.377,0,0,1,4.56-2.64c2.274-.92,5-1.6,5.831-.062,1.5,2.789-18.253,9.662-18.253,9.662S1002.994,603.578,1003.208,599.5Z",
    transform: "translate(-669.802 -414.203)",
    fill: "#00587f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1305",
    "data-name": "Pfad 1305",
    d: "M891.648,360.824a2.548,2.548,0,0,1-.963,1.952,5.307,5.307,0,0,1-1.782.424,4.143,4.143,0,0,0-2.836,2.448,6.345,6.345,0,0,0-.268,3.821,14.079,14.079,0,0,0,.547,1.836,17.385,17.385,0,0,0,2.568,5.03,21.363,21.363,0,0,0,3.368,3.173,5.813,5.813,0,0,0,4.455,1.811,4.33,4.33,0,0,0,2.387-.34c1.087-.627,1.412-2.014,2-3.122.5-.945,1.25-1.742,1.717-2.705a10.787,10.787,0,0,0,.724-2.358l1-4.458c.362-1.615.7-3.441-.217-4.828a.761.761,0,0,0-.268-.279,1,1,0,0,0-.547-.058,5.91,5.91,0,0,1-3.314-.757,1.312,1.312,0,0,1-.417-.326,1.641,1.641,0,0,1-.257-.764,8.07,8.07,0,0,0-.464-1.615,1.086,1.086,0,0,0-.315-.482,1.127,1.127,0,0,0-.507-.17,41.457,41.457,0,0,0-4.683-.493c-.518-.022-1.293-.228-1.644.225S891.706,360.281,891.648,360.824Z",
    transform: "translate(-594.809 -263.667)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1306",
    "data-name": "Pfad 1306",
    d: "M891.648,360.824a2.548,2.548,0,0,1-.963,1.952,5.307,5.307,0,0,1-1.782.424,4.143,4.143,0,0,0-2.836,2.448,6.345,6.345,0,0,0-.268,3.821,14.079,14.079,0,0,0,.547,1.836,17.385,17.385,0,0,0,2.568,5.03,21.363,21.363,0,0,0,3.368,3.173,5.813,5.813,0,0,0,4.455,1.811,4.33,4.33,0,0,0,2.387-.34c1.087-.627,1.412-2.014,2-3.122.5-.945,1.25-1.742,1.717-2.705a10.787,10.787,0,0,0,.724-2.358l1-4.458c.362-1.615.7-3.441-.217-4.828a.761.761,0,0,0-.268-.279,1,1,0,0,0-.547-.058,5.91,5.91,0,0,1-3.314-.757,1.312,1.312,0,0,1-.417-.326,1.641,1.641,0,0,1-.257-.764,8.07,8.07,0,0,0-.464-1.615,1.086,1.086,0,0,0-.315-.482,1.127,1.127,0,0,0-.507-.17,41.457,41.457,0,0,0-4.683-.493c-.518-.022-1.293-.228-1.644.225S891.706,360.281,891.648,360.824Z",
    transform: "translate(-594.809 -263.667)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1307",
    "data-name": "Pfad 1307",
    d: "M878.378,370.328a9.935,9.935,0,0,0-2.586-.409,6.469,6.469,0,0,0-5.483,2.358,5.567,5.567,0,0,0-.829,4.147,8.587,8.587,0,0,0,1.883,3.864,11.617,11.617,0,0,1,1.449,1.9,10.056,10.056,0,0,1,.724,3.622c.362,2.937,1.615,5.7,2.115,8.623s.065,6.309-2.242,8.17c-.388.311-.855.637-.887,1.134-.054.793.978,1.134,1.771,1.206a20.186,20.186,0,0,0,7.109-.163c.956-.254,1.872-.648,2.843-.829,2.466-.46,4.943.482,7.406.938a33.253,33.253,0,0,0,5.4.438,2.9,2.9,0,0,0,1.246-.163,1,1,0,0,0,.63-.992,1.681,1.681,0,0,0-.427-.724,11.809,11.809,0,0,1-1.967-5.537l-1.123-6.573c-.612-3.506-1.181-7.312.478-10.463,1.2-2.263,3.39-3.857,4.65-6.084a2.954,2.954,0,0,0-1.662-4.676,8.406,8.406,0,0,0-6.3-.228,25.431,25.431,0,0,1-.623,4.708l-.438,2.535a32.279,32.279,0,0,1-.978,4.418,4.789,4.789,0,0,1-.786,1.6,4.138,4.138,0,0,1-1.387,1.01,8.243,8.243,0,0,1-3.676.837,4.825,4.825,0,0,1-1.622-.246,6.932,6.932,0,0,1-2.235-1.575,3.653,3.653,0,0,1-.59-.637,3.848,3.848,0,0,1-.4-.967,19.677,19.677,0,0,1-.688-2.709c-.112-.7-.145-1.416-.2-2.126A51.645,51.645,0,0,0,878.378,370.328Z",
    transform: "translate(-584.447 -270.607)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1308",
    "data-name": "Pfad 1308",
    d: "M888.121,486.75s-.858,11.379,4.509,13.313.645-9.449.645-9.449l-1.717-3.437Z",
    transform: "translate(-596.371 -345.471)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1309",
    "data-name": "Pfad 1309",
    d: "M926.152,486.75s.858,11.379-4.509,13.313-.645-9.449-.645-9.449l1.717-3.437Z",
    transform: "translate(-616.148 -345.471)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1310",
    "data-name": "Pfad 1310",
    d: "M872.147,380.656l-1.717,2.792s1.5,9.662,1.717,11.379a22.4,22.4,0,0,0,.858,3.643s.214,5.154.214,7.084a21.629,21.629,0,0,0,1.086,5.154,23.371,23.371,0,0,0,1.087,5.367c.858,2.365,1.72,5.154,1.72,5.154s1.086-3.006,5.367,1.5a2.6,2.6,0,0,0,0-3.651,56.806,56.806,0,0,1-1.289-8.8c0-3.006-2.361-17.384-2.361-17.384S877.3,376.575,872.147,380.656Z",
    transform: "translate(-585.119 -277.382)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1311",
    "data-name": "Pfad 1311",
    d: "M870.977,380.075l-1.717,2.789s1.5,9.662,1.717,11.383a22.541,22.541,0,0,0,.862,3.647s.225,5.154.225,7.091a21.536,21.536,0,0,0,1.086,5.154,23.473,23.473,0,0,0,1.087,5.367c.858,2.361,1.717,5.154,1.717,5.154s1.086-3.006,5.367,1.5a2.6,2.6,0,0,0,0-3.651,56.8,56.8,0,0,1-1.289-8.8c0-3.01-2.361-17.384-2.361-17.384S876.123,376.011,870.977,380.075Z",
    transform: "translate(-584.373 -277.014)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1312",
    "data-name": "Pfad 1312",
    d: "M932.348,374.93l1.086,1.278a39.453,39.453,0,0,1-1.525,16.544l-.858,8.377s-1.5,7.084-1.72,8.8-.214,1.93-.641,2.575a.826.826,0,0,0,0,1.086l-1.289,4.726s-1.934-2.361-5.795.645a3.408,3.408,0,0,1-.214-3.223c.873-1.5.858-2.148.645-2.575s.858-2.579.858-3.006,1.5-10.307,1.5-10.307.645-9.663,1.289-12.882a60.267,60.267,0,0,0,.319-9.507,3.639,3.639,0,0,1,6.157-2.713A1.685,1.685,0,0,1,932.348,374.93Z",
    transform: "translate(-617.408 -273.377)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1313",
    "data-name": "Pfad 1313",
    d: "M934.108,372.9l1.086,1.278a39.525,39.525,0,0,1-1.525,16.544l-.858,8.373s-1.5,7.088-1.72,8.8-.214,1.934-.645,2.575a.837.837,0,0,0,0,1.086l-1.286,4.708s-1.934-2.361-5.795.645a3.4,3.4,0,0,1-.214-3.22c.873-1.5.858-2.148.641-2.579s.862-2.575.862-3.006,1.5-10.307,1.5-10.307.645-9.662,1.286-12.882.217-12.882.217-12.882A4.967,4.967,0,0,1,934.108,372.9Z",
    transform: "translate(-618.531 -271.772)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_559",
    "data-name": "Ellipse 559",
    cx: 8.59,
    cy: 8.59,
    r: 8.59,
    transform: "translate(292.609 80.94)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1314",
    "data-name": "Pfad 1314",
    d: "M906.84,307.406a6.012,6.012,0,0,1-11.26.159,10.656,10.656,0,0,1,6.78-.145A6.076,6.076,0,0,1,906.84,307.406Z",
    transform: "translate(-601.16 -230.772)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1315",
    "data-name": "Pfad 1315",
    d: "M891.225,308.611s-16.533-5.795-12.455,22.331c0,0,3.651,2.361,6.443.858,0,0-1.934-19.557,5.581-18.68s6.229,18.249,6.229,18.249,4.3,1.289,5.581-1.086S902.177,304.743,891.225,308.611Z",
    transform: "translate(-590.026 -231.532)",
    fill: "#00273c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1316",
    "data-name": "Pfad 1316",
    d: "M902.9,318.321c-5.157-.59-5.863,8.424-5.795,14.142.065-5.682,1.021-13.4,5.795-12.853,5.367.612,6.244,9.652,6.309,14.773C909.264,329.686,908.75,318.991,902.9,318.321Z",
    transform: "translate(-602.129 -238.023)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1317",
    "data-name": "Pfad 1317",
    d: "M878.779,354.453a58.372,58.372,0,0,1-.641-7.453,55.129,55.129,0,0,0,.641,8.728s3.651,2.361,6.443.858c0,0-.047-.464-.1-1.242C882.346,356.778,878.779,354.453,878.779,354.453Z",
    transform: "translate(-590.035 -256.333)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1318",
    "data-name": "Pfad 1318",
    d: "M935.891,361.526c-1.2,2.2-5.005,1.235-5.523,1.087-.025.8-.058,1.271-.058,1.271s4.3,1.289,5.581-1.086a9.792,9.792,0,0,0,.362-3.7A6.7,6.7,0,0,1,935.891,361.526Z",
    transform: "translate(-623.313 -264.051)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_591",
    "data-name": "Rechteck 591",
    width: 58,
    height: 17,
    rx: 6,
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 47.314, 274.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "FLEETLINK",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 75.843, 287.997)",
    fill: "#00587f",
    fontSize: 9,
    fontFamily: "MavenPro-Bold, Maven Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.224,
    y: 0
  }, "FLEETLINK")), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_568",
    "data-name": "Ellipse 568",
    cx: 186.6,
    cy: 23.45,
    rx: 186.6,
    ry: 23.45,
    transform: "translate(0.204 316.832) rotate(-6)",
    fill: "#00587f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_593",
    "data-name": "Rechteck 593",
    width: 58,
    height: 17,
    rx: 6,
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 47.314, 274.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "FLEETLINK-2",
    "data-name": "FLEETLINK",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 75.843, 287.997)",
    fill: "#00587f",
    fontSize: 9,
    fontFamily: "MavenPro-Bold, Maven Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.224,
    y: 0
  }, "FLEETLINK")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVehicle);
export default __webpack_public_path__ + "static/media/add-vehicle.43b63950.svg";
export { ForwardRef as ReactComponent };